// @ts-strict-ignore
/**
 * @fileoverview GET handler for the "/app_settings/api_settings_info_datatable(/:app_group_id)" endpoint
 */
import fetch from "@lib/fetch";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsApiSettingsInfoDatatableAppGroupId } from "./constants";
import type {
  AppSettingsApiSettingsInfoDatatableAppGroupIdParams,
  AppSettingsApiSettingsInfoDatatableAppGroupIdResult,
} from "./types";

export const getDataTableAppSettingsApiSettingsInfoDatatableAppGroupId = reactQueryTableFetcherAdapter(
  appSettingsApiSettingsInfoDatatableAppGroupId,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query,
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
    }: AppSettingsApiSettingsInfoDatatableAppGroupIdParams
  ): Promise<AppSettingsApiSettingsInfoDatatableAppGroupIdResult> => {
    return fetch(
      `/app_settings/api_settings_info_datatable${appGroupId ? `/${appGroupId}` : ""}`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        query: serializeQueryObjects(query),
      },
      { signal }
    );
  }
);
